import { render, staticRenderFns } from "./simplifyHisFee.vue?vue&type=template&id=d13b2e8c&scoped=true"
import script from "./simplifyHisFee.vue?vue&type=script&lang=js"
export * from "./simplifyHisFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyHisFee.vue?vue&type=style&index=0&id=d13b2e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13b2e8c",
  null
  
)

export default component.exports